import { ApiService } from "./ApiService";
import { ResultsDTO } from "Types/ResultsDTO";

export const productFilterApi = ApiService.injectEndpoints({
  endpoints: (builder) => ({
    getAllPrdCollarMst: builder.query<string[], { plant: string; search?: string }>({
      query: ({ plant, search }) =>
        `/ProductFilter/getAllPrdCollarMst?plant=${plant}${search ? `&search=${search}` : ''}`,
      transformResponse: (res: ResultsDTO<string[]>) => res.results ?? [],
    }),
    getAllPrdColorMst: builder.query<string[], { plant: string; search?: string }>({
      query: ({ plant, search }) =>
        `/ProductFilter/getAllPrdColorMst?plant=${plant}${search ? `&search=${search}` : ''}`,
      transformResponse: (res: ResultsDTO<string[]>) => res.results ?? [],
    }),
    getAllPrdFabricMst: builder.query<string[], { plant: string; search?: string }>({
      query: ({ plant, search }) =>
        `/ProductFilter/getAllPrdFabricMst?plant=${plant}${search ? `&search=${search}` : ''}`,
      transformResponse: (res: ResultsDTO<string[]>) => res.results ?? [],
    }),
    getAllPrdOccasionMst: builder.query<string[], { plant: string; search?: string }>({
      query: ({ plant, search }) =>
        `/ProductFilter/getAllPrdOccasionMst?plant=${plant}${search ? `&search=${search}` : ''}`,
      transformResponse: (res: ResultsDTO<string[]>) => res.results ?? [],
    }),
    getAllPrdPatternMst: builder.query<string[], { plant: string; search?: string }>({
      query: ({ plant, search }) =>
        `/ProductFilter/getAllPrdPatternMst?plant=${plant}${search ? `&search=${search}` : ''}`,
      transformResponse: (res: ResultsDTO<string[]>) => res.results ?? [],
    }),
    getAllPrdSizeMst: builder.query<string[], { plant: string; search?: string }>({
      query: ({ plant, search }) =>
        `/ProductFilter/getAllPrdSizeMst?plant=${plant}${search ? `&search=${search}` : ''}`,
      transformResponse: (res: ResultsDTO<string[]>) => res.results ?? [],
    }),
    getAllPrdSleeveMst: builder.query<string[], { plant: string; search?: string }>({
      query: ({ plant, search }) =>
        `/ProductFilter/getAllPrdSleeveMst?plant=${plant}${search ? `&search=${search}` : ''}`,
      transformResponse: (res: ResultsDTO<string[]>) => res.results ?? [],
    }),
  })
});

export const {
  useGetAllPrdCollarMstQuery,
  useGetAllPrdColorMstQuery,
  useGetAllPrdFabricMstQuery,
  useGetAllPrdOccasionMstQuery,
  useGetAllPrdPatternMstQuery,
  useGetAllPrdSizeMstQuery,
  useGetAllPrdSleeveMstQuery
} = productFilterApi;
